"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainContext = void 0;
const react_1 = require("react");
exports.DomainContext = (0, react_1.createContext)({});
